import { render } from "./TrialCustomerDetail.vue?vue&type=template&id=2bbd0f82&scoped=true"
import script from "./TrialCustomerDetail.vue?vue&type=script&lang=js"
export * from "./TrialCustomerDetail.vue?vue&type=script&lang=js"

import "./TrialCustomerDetail.vue?vue&type=style&index=0&id=2bbd0f82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbd0f82"]])

export default __exports__